import React from "react";
import { motion } from "framer-motion";

const OFFERS = [
  "We map your current signal architecture — what Meta is learning from your CRM and what it isn't",
  "We calculate your real cost per paying patient — most clinics have never seen this number",
  "We identify which of the three pillars is causing the quality leak in your specific setup",
  "Written findings included. No proposal, no pitch.",
];

export default function CTA({ onCalendarClick }) {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: "var(--rtd-navy)", padding: "96px 24px" }}
      data-testid="cta-section"
    >
      <div className="mx-auto text-center" style={{ maxWidth: 640 }}>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-body"
          style={{
            fontWeight: 700,
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            color: "var(--rtd-gold)",
            marginBottom: 16,
          }}
        >
          Right to Digital — Signal Diagnostic
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="font-serif-display text-[30px] sm:text-[40px]"
          style={{ color: "var(--rtd-on-dark)", lineHeight: 1.15 }}
        >
          Find out exactly where your signal is breaking.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-body mx-auto"
          style={{
            fontSize: 17,
            color: "var(--rtd-on-dark-soft)",
            lineHeight: 1.7,
            maxWidth: 520,
            marginTop: 20,
          }}
        >
          If your clinic spends ₹1 lakh or more per month on paid ads and is not seeing the
          patient quality your procedure offering deserves, this is a 20-minute diagnostic
          call. No pitch. No deck. Written findings you can act on.
        </motion.p>

        <div
          className="mx-auto text-left"
          style={{ maxWidth: 480, margin: "40px auto 32px" }}
        >
          {OFFERS.map((offer, i) => (
            <motion.div
              key={offer}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: 0.15 + i * 0.08 }}
              className="flex items-start"
              style={{ gap: 12, marginBottom: i < OFFERS.length - 1 ? 24 : 0 }}
              data-testid={`cta-offer-${i + 1}`}
            >
              <span
                aria-hidden="true"
                className="font-body shrink-0"
                style={{ color: "var(--rtd-gold)", fontWeight: 700, lineHeight: 1.5, fontSize: 14 }}
              >
                →
              </span>
              <span
                className="font-body"
                style={{ fontSize: 14, color: "var(--rtd-on-dark-soft)", lineHeight: 1.5 }}
              >
                {offer}
              </span>
            </motion.div>
          ))}
        </div>

        {/* GHL Calendar CTA */}
        <motion.button
          type="button"
          onClick={() => onCalendarClick && onCalendarClick("cta_section")}
          data-testid="cta-book-button"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          whileHover={{ opacity: 0.9 }}
          className="font-body inline-block w-full sm:w-auto"
          style={{
            maxWidth: 320,
            backgroundColor: "var(--rtd-gold)",
            color: "var(--rtd-navy)",
            fontWeight: 700,
            fontSize: 16,
            padding: "18px 40px",
            borderRadius: 8,
            border: "none",
            textDecoration: "none",
            cursor: "pointer",
            transition: "opacity 200ms ease",
            boxShadow: "0 12px 32px rgba(232,160,32,0.25)",
          }}
        >
          Book a 20-minute signal diagnostic →
        </motion.button>

        <p
          className="font-body"
          style={{ fontSize: 13, color: "#7A94A8", marginTop: 20 }}
          data-testid="cta-fineprint"
        >
          For health and wellness brands spending ₹1L+ per month on paid ads · Founder-led · Written findings
          included
        </p>
      </div>
    </section>
  );
}
